import type { TimeReportsV2Item } from "services/api/company/timeReports.service";
import type { PersonDetailSelection } from "../models/personView.types";

interface RefreshOpenedDetailParams {
  readonly latestItemsById: ReadonlyMap<number, TimeReportsV2Item>;
  readonly openedDetail: PersonDetailSelection | null;
}

export function refreshOpenedDetail({
  openedDetail,
  latestItemsById,
}: RefreshOpenedDetailParams): PersonDetailSelection | null {
  if (!openedDetail) return null;

  const latestItem = latestItemsById.get(openedDetail.item.id);
  if (!latestItem || openedDetail.item === latestItem) return openedDetail;

  return { ...openedDetail, item: latestItem };
}
